// Format a raw session-history payload into the shape the chat UI consumes.
// Shared by ChatSection (on load/refresh) and useChatSubmit (after streaming)
// so the entity/action buttons derived from intermediate_steps are populated
// consistently in both cases.

export function formatSessionHistory(history) {
  return (history || []).flatMap(item => {
    const isSource = item?.sources ? item?.sources : [];
    const websearchSources = isSource?.filter(src => src.type === 'google_search');
    const fileSources = isSource?.filter(src => src.type === 'file');
    return [
      {
        human: item.human,
        ai: item?.ai,
        isStreaming: false,
        intermediate_steps: [
          {
            tool_name: 'thinking...',
            content: item.human,
          },
          ...(item?.intermediate_steps || []),
        ],
        source: websearchSources.length > 0 ? websearchSources : [],
        files: fileSources.length > 0 ? fileSources : [],
        images: item?.images,
        isLoading: false,
      },
    ];
  });
}
